import { Component, OnInit } from '@angular/core';
import { TraductorService } from '../../servicios/traductor.service';
import { Subscription } from 'rxjs';

import * as Info from '../../../assets/JsonEstructura/footer.json';

const footerD = JSON.stringify(Info);
const dataFooter = JSON.parse(footerD);

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public idioma:string;
  public suscription : Subscription
  public data: any;
  constructor( 
    private _traductorService :TraductorService
  ) { 
    this.idioma = localStorage.getItem("idioma")
    this.data = new Array(dataFooter);
  }

  ngOnInit() {
    this.suscription = this._traductorService.getEvento().subscribe({
      next: result => {
        if(result){
          if(result == 2){
            this.idioma = "2"
            localStorage.setItem("idioma",this.idioma);
          }else if(result == 3){
            this.idioma = "3"
            localStorage.setItem("idioma",this.idioma);
          }else if(result == 4){
            this.idioma = "4"
            localStorage.setItem("idioma",this.idioma);
          }
          else if(result == 5){
            this.idioma = "5"
            localStorage.setItem("idioma",this.idioma);
          }else if(result == 6){
            this.idioma = "6"
            localStorage.setItem("idioma",this.idioma);
          }else if(result == 7){
            this.idioma = "7"
            localStorage.setItem("idioma",this.idioma)
          }else if(result == 8){
            this.idioma = "8"
            localStorage.setItem("idioma",this.idioma)
          }
        }
      }
    })
  }
}
